(function() {
    var WORKING_CONDITION = 'WORKING',
        DAMAGED_CONDITION = 'DAMAGED',
        DISABLED_SUBMIT_TEXT = 'Please finish the form to continue',
        DEFAULT_SUBMIT_TEXT = 'Next Step: Get your free envelope',
        MICRO_SUBMIT_TEXT = 'Add to purchase',
        DISABLED_MICRO_SUBMIT_TEXT = 'Please finish the form to continue',
        CONDITION_INFORMATION = {
            'WORKING': {
                title: 'WORKING Condition',
                content: 'Your device is fully functional – although there might be some signs of cosmetic damage.',
            },
            'DAMAGED': {
                title: 'DAMAGED Condition',
                content: 'Your device doesn\'t power up, or has a cracked screen or case, or damaged keyboard',
            },
            'RECYCLE': {
                title: 'Thank you for choosing to recycle your phone with us',
                content: 'Your device is crushed, bent or smashed beyond repair.',
            },
            'RECYCLE-ONLY': {
                title: 'Unfortunately this phone has no reuse value',
                content: 'Help the planet and recycle your phone with us.',
            }
        },
        state = {
            condition: '',
            offerName: '',
            network: {
                selected: '',
                visible: false,
            },
            offerPrice: {
                value: 0.00,
                enabled: false,
            },
        },
        selectors = {
            conditionRadio: '[data-condition-key]',
            conditionInformationBox: '[data-condition-information]',
            conditionInfoTitle: '[data-condition-info-title]',
            conditionInfoContent: '[data-condition-info-content]',
            conditionRequiredMessage: '[data-condition-required]',
            networkListJson: '[data-networks-list-json]',
            networkList: '[data-networks-list]',
            networkListBox: '[data-networks-list-box]',
            offerPrice: '[data-offer-price]',
            submitButton: '[data-submit]',
            addToPurchaseButton: '[data-add-to-purchase]',
            productConditionTab: '[data-condition-tab]',
            productValueTab: '[data-value-tab]',
            productValueBackButton: '[data-value-back-button]',
            modelIdInput: '[data-model-id-input]',
            deviceNameInput: '[data-device-name-input]',
            networkKey: '[data-network-key]',
            tradeInPrice: '[data-trade-in-price]'
        };

    var NETWORK_LIST = {
        'UNLOCKED': 'Unlocked',
        'VODAFONE': 'Vodafone',
        'T-MOBILE': 'T-Mobile',
        'ORANGE': 'Orange',
        'TESCO': 'Tesco',
        'THREE': 'Three',
        'UNKNOWN': 'Unknown',
        'ID': 'iD Mobile'
    };

    function addNetworkButtons() {
        var networksHtml = '<div>\n';

        $.each(JSON.parse($(selectors.networkListJson).text()), function(key, value) {
            var activeNetwork = (state.network.selected === value.network) ? ' active' : '';
            networksHtml +=
                '<label class="zero-margin" data-network-key="' + key + '" ' +
                       'data-network-name="' + value.network + '" ' +
                       'data-network-price="' + value.price + '">' +
                    '<input class="sr-only" type="radio" name="network" value="' + key + '"' + (activeNetwork ? 'checked>' : '>') +
                    '<span class="checkable-btn inline-block margin-right-plus-5px margin-bottom-plus-10px">' + (NETWORK_LIST[value.network] ? NETWORK_LIST[value.network] : value.network) + '</span>' +
                '</label> ';
        });

        networksHtml += '</div>\n';
        $(selectors.networkList).html(networksHtml);
    }

    function setState(data) {
        $.each(data, function(key, value) {
            state[key] = value;
        });
    }

    var isTradeInMicro = function() {
        return $('[data-micro-trade-in-component]').length > 0 || $('[data-micro-trade-in-component-ab]').length > 0;
    };

    function renderView() {
        var conditionState = state.condition,
            workingDisabled = $('[data-condition-key="' + WORKING_CONDITION + '"]').attr('disabled'),
            damagedDisabled = $('[data-condition-key="' + DAMAGED_CONDITION + '"]').attr('disabled'),
            conditionInfoKey = (workingDisabled === 'disabled' && damagedDisabled === 'disabled') ? 'RECYCLE-ONLY' : conditionState,
            submitURL = $(selectors.submitButton).data('confirmation-path') + '/' + state.offerName;

        if (state.network.visible === true) {
            addNetworkButtons();
            $(selectors.networkListBox).removeClass('hide');
        } else {
            $(selectors.networkList).text('');
            $(selectors.networkListBox).addClass('hide');
        }

        if (conditionInfoKey !== '') {
            $(selectors.conditionInformationBox).show();
            $(selectors.conditionInfoTitle).html(CONDITION_INFORMATION[conditionInfoKey].title);
            $(selectors.conditionInfoContent).html(CONDITION_INFORMATION[conditionInfoKey].content);
        } else {
            $(selectors.conditionInformationBox).hide();
            $(selectors.conditionInfoTitle).html('');
            $(selectors.conditionInfoContent).html('');
        }

        var $addToPurchaseButton = $(selectors.addToPurchaseButton);

        if (state.offerPrice.enabled === true) {
            $(selectors.offerPrice).text(state.offerPrice.value.toFixed(2));
            $(selectors.submitButton).text(DEFAULT_SUBMIT_TEXT);
            $(selectors.submitButton).attr('href', submitURL);
            $(selectors.submitButton).removeClass('disabled btn-gray-shade-2').addClass('btn-hi-sky');

            if ($('[data-micro-trade-in-component-ab]').length) {
                $addToPurchaseButton
                    .text('Add Freepost bag to Basket*').removeClass('disabled btn-gray-shade-2').addClass('btn-hi-sky');
                $addToPurchaseButton.after('<p class="font-size-12 margin-top-plus-10px">*If you change your mind you can keep hold of the bag until you’re ready. If your phone is received more than 14 days after your original quote, and the quote changes we will contact you to confirm you’re happy with the valuation.</p>');
            } else {
                $addToPurchaseButton
                    .text(MICRO_SUBMIT_TEXT).removeClass('disabled btn-gray-shade-2').addClass('btn-hi-sky');
            }

            $addToPurchaseButton
                .attr('data-model-id', $(selectors.modelIdInput).val())
                .attr('data-device-name', $(selectors.deviceNameInput).val())
                .attr('data-offer', state.offerName)
                .attr('data-network', state.network.visible ? state.network.selected : null)
                .attr('data-quoted-price', state.offerPrice.value);

            $(selectors.productConditionTab).removeClass('active');
            $(selectors.productValueTab).addClass('active');
            if (isTradeInMicro()) {
                window.dataLayer.push({
                    'event': 'tradeInModalStepChange',
                    'modalStep': 'Step 4 - Find A Phone'
                });
            }

        } else {
            $(selectors.offerPrice).text('___.__');
            $(selectors.submitButton).text(DISABLED_SUBMIT_TEXT);
            $(selectors.submitButton).attr('href', submitURL);
            $(selectors.submitButton).addClass('disabled btn-gray-shade-2').removeClass('btn-hi-sky');

            $addToPurchaseButton
                .text(DISABLED_MICRO_SUBMIT_TEXT).addClass('disabled btn-gray-shade-2').removeClass('btn-hi-sky');
        }
    }

    $(document).on('click', '.upSellDataLayer', function() {
        var upsellDeal = $(this).data('upsell');
        let promotionalDataLength = $(this).attr('data-upsellMonthlyLength');
        let promotionalCost = $(this).attr('data-upsellMonthlyCost');
        if (upsellDeal != null) {
            var upsell = determineUpsell(upsellDeal);
            let promotions = upsellDeal.promotions;
            let dealType = $(this).attr('data-deal-type');
            dataLayer = window.dataLayer || [];
            if (dealType == 'sim') {
                window.dataLayer.push({
                    'event': 'sim_upsell_modal',
                    'clicked_sim': '£' + $(this).attr('data-monthly-cost') + ' ' + $(this).attr('data-original-data') + ' ' + $(this).attr('data-monthly-length') + 'M' + (promotionalDataLength && promotionalCost ? ', ' + promotionalDataLength + ' Month' + ((promotionalDataLength > 1) ? 's' : '') + ' Half Price' : '') + (($(this).attr('data-deal-tag') != '') ? ', ' + $(this).attr('data-deal-tag') : ''),
                    'recommended_sim': '£' + upsell.monthlyCost + ' ' + upsell.displayData + upsell.dataUnit + ' ' + upsell.contractLength + 'M' + ((promotions.length != 0 && promotions.hasOwnProperty('monthly_cost')) ? ', ' + promotions.monthly_cost.duration + ' Month' + ((promotions.monthly_cost.duration > 1) ? 's' : '') + ' Half Price' : '')
                });
            }
            if (dealType == 'handset') {
                window.dataLayer.push({
                    'event': 'handset_upsell_modal',
                    'clicked_handset': '£' + $(this).attr('data-monthly-cost') + ' ' + $(this).attr('data-original-data') + ' ' + $(this).attr('data-monthly-length') + 'M' + (promotionalDataLength && promotionalCost ? ', ' + promotionalDataLength + ' Month' + ((promotionalDataLength > 1) ? 's' : '') + ' Half Price' : '') + (($(this).attr('data-deal-tag') != '') ? ', ' + $(this).attr('data-deal-tag') : ''),
                    'recommended_handset': '£' + upsell.monthlyCost + ' ' + upsell.displayData + upsell.dataUnit + ' ' + upsell.contractLength + 'M' + ((promotions.length != 0 && promotions.hasOwnProperty('monthly_cost')) ? ', ' + promotions.monthly_cost.duration + ' Month' + ((promotions.monthly_cost.duration > 1) ? 's' : '') + ' Half Price' : '')
                });
            }
        }
    });
    function determineUpsell(upsellDeal) {
        var upsellData = upsellDeal.data,
            dataAttributes = calculateData(upsellData === 'Unlimited', upsellData);

        return {
            'heading': upsellDeal.heading,
            'subheading': upsellDeal.sub_heading,
            'displayData': dataAttributes.displayData,
            'dataUnit': dataAttributes.dataUnit,
            'displayMins': upsellDeal.minutes,
            'displayTexts': upsellDeal.texts,
            'monthlyCost': upsellDeal.monthly_cost,
            'contractLength': upsellDeal.contract_length,
        };
    }

    function calculateData(isUnlimitedData, upsellData) {
        if (isUnlimitedData) {
            return {
                'displayData': upsellData,
                'dataUnit': '',
            };
        }

        return {
            'displayData': (upsellData < 1000) ? upsellData : (upsellData / 1000),
            'dataUnit': (upsellData < 1000) ? 'MB' : 'GB',
        };
    }
    function checkHandsetCondition() {
        $(selectors.conditionRequiredMessage).toggleClass('hide', !$(selectors.submitButton).hasClass('disabled'));
    }

    function networkButtonOnClick() {
        var $this = $(this);

        setState({
            condition: WORKING_CONDITION,
            offerName: $this.data('network-key'),
            network: {
                selected: $this.data('network-name'),
                visible: true,
            },
            offerPrice: {
                value: $this.data('network-price'),
                enabled: true,
            }
        });

        renderView();
    }

    var backToCondition = function() {
        $(selectors.productConditionTab).addClass('active');
        $(selectors.productValueTab).removeClass('active');
        $(selectors.conditionRadio).prop('checked', false);
        $(selectors.networkKey + ' input[type=radio]').prop('checked', false);
        $(selectors.networkListBox).addClass('hide');
        $(selectors.conditionInformationBox).hide();
    };

    $(document).on('click', selectors.conditionRadio, function() {
        var $this = $(this),
            condition = $this.data('condition-key');

        $(selectors.conditionRequiredMessage).addClass('hide');

        setState({
            condition: condition,
            offerName: $this.data('condition-offer-name')
        });

        if (condition === WORKING_CONDITION && $(selectors.networkListJson).text() !== '') {
            setState({
                network: {
                    selected: '',
                    visible: true,
                },
                offerPrice: {
                    value: $this.data('condition-price'),
                    enabled: false,
                }
            });
        } else {
            setState({
                network: {
                    selected: '',
                    visible: false,
                },
                offerPrice: {
                    value: $this.data('condition-price'),
                    enabled: true,
                }
            });
        }

        renderView();
    });

    function init() {
        $(document)
            .on('click', selectors.networkKey, networkButtonOnClick)
            .on('click', selectors.tradeInPrice, checkHandsetCondition)
            .on('click', selectors.productValueBackButton, backToCondition);
        renderView();
    }

    init();
})($);
